// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event Property Definition: https://pap.pp.dropbox.com/#/event_property/2932

import type { DashProfilingIndustry } from "./dash_profiling_industry";

const DashProfilingIndustryValues: DashProfilingIndustry[] = [
    "architecture_engineering_construction",
    "capital_markets",
    "education",
    "financial_services",
    "government",
    "healthcare",
    "manufacturing",
    "media_or_sports",
    "professional_services",
    "technology",
    "other",
];

export function getDashProfilingIndustryFromString(s: string): DashProfilingIndustry | undefined {
    return DashProfilingIndustryValues.find(e => e === s?.toLowerCase());
}
